import { Form as FormikForm, useFormikContext } from 'formik'
import { HTMLAttributes, PropsWithChildren } from 'react'
import cx from 'classnames'
import Styles from './Form.module.scss'

export const Form = ({ children, ...rest }: PropsWithChildren<HTMLAttributes<HTMLFormElement>>) => {
  const { status } = useFormikContext()
  return (
    <FormikForm {...rest} className={cx(rest.className, { [Styles.loading]: status === 'loading' })}>
      {children}
    </FormikForm>
  )
}
